import { gql } from "@apollo/client";

export const addUsers = gql`
  mutation AddUsers($input: [UserInput!]!) {
    addUsers(input: $input) {
      user {
        email
        id
        firstName
        lastName
        organizationId
      }
    }
  }
`;

export const reassignUserRole = gql`
  mutation ReassignRoleForAUser(
    $userId: ID!
    $accountHolderId: ID!
    $newRoleId: ID!
    $otp: String
  ) {
    reassignRoleForAUser(
      userId: $userId
      accountHolderId: $accountHolderId
      newRoleId: $newRoleId
      otp: $otp
    ) {
      message
      newRoleId
      userId
      accountHolderId
    }
  }
`;

export const reassignMultipleUsersRole = gql`
  mutation ReassignRolesForMultipleUsers(
    $userRoles: [UsersRolesInput]!
    $accountHolderId: ID!
    $otp: String
  ) {
    reassignRolesForMultipleUsers(
      userRoles: $userRoles
      accountHolderId: $accountHolderId
      otp: $otp
    ) {
      message
      users {
        userId
        newRole
        message
      }
      otp
    }
  }
`;

export const assignPermission = gql`
  mutation AssignRolePermission($roleId: ID!, $permissionId: ID!) {
    assignRolePermission(roleId: $roleId, permissionId: $permissionId)
  }
`;

export const removeRolePermission = gql`
  mutation RemoveRolePermission($roleId: ID!, $permissionId: ID!) {
    removeRolePermission(roleId: $roleId, permissionId: $permissionId)
  }
`;

export const activateOrDeactivate2FA = gql`
  mutation ActivateOrDeactivate2FA($phone: String) {
    activateOrDeactivate2FA(phone: $phone) {
      message
      otpSent
    }
  }
`;
export const verify2FA = gql`
  mutation Verify2FA($otp: String!) {
    verify2FA(otp: $otp) {
      success
      message
    }
  }
`;
